import {
  createBuilding,
  clearGetBuildingByBuildingId,
  getBuildingByBuildingId,
  updateBuilding,
} from "../../../../Redux/Buildings/BuildingActions";
import { AppDispatch, RootState } from "../../../../Redux/store";
import imageUrlHelper from "../../../../Util/imageUrlHelper";
import imageToBase64 from "../../../../Util/imageToBase64";
import React, { useEffect, useRef, useState } from "react";
import LocalData from "../../../../LocalData/LocalData";
import styles from "./BuildingInformation.module.scss";
import toastHelper from "../../../../Util/toastHelper";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import validator from "../../../../Util/validator";
import { FaRegEyeSlash } from "react-icons/fa6";
import { FaRegEye } from "react-icons/fa6";
import { CiImageOn } from "react-icons/ci";
import { IoClose } from "react-icons/io5";

interface BuildingInformationProps {
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  buildingId: string;
}

function BuildingInformation(props: BuildingInformationProps) {
  const { setActiveTab, buildingId } = props;
  const ref = useRef<HTMLInputElement>(null);
  const guideImage1Ref = useRef<HTMLInputElement>(null);
  const guideImage2Ref = useRef<HTMLInputElement>(null);
  const guideImage3Ref = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [lockProviderId, setLockProviderId] = useState("");
  const [lockProviderEndpoint, setLockProviderEndpoint] = useState("");
  const [image, setImage] = useState<File | string | null>(null);
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [amenigiesShare, setAmenigiesShare] = useState("");
  const [ownerShare, setOwnerShare] = useState("");
  const [guideImage1, setGuideImage1] = useState<File | string | null>(null);
  const [guideImage2, setGuideImage2] = useState<File | string | null>(null);
  const [guideImage3, setGuideImage3] = useState<File | string | null>(null);
  const [selectedGroup, setSelectedGroup] = useState("");
  const {
    lockProviders,
    createBuildingLoading,
    updateBuildingLoading,
    getBuildingById,
    getBuildingByIdLoading,
  } = useSelector((state: RootState) => state.buildings);

  const { allGroups } = useSelector((state: RootState) => state.groups);

  const [errors, setErrors] = useState<{
    name: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    lockProviderId: string;
    lockProviderEndpoint: string;
    image: string;
    lat: string;
    long: string;
    username: string;
    password: string;
    amenigiesShare: string;
    ownerShare: string;
    selectedGroup: string;
    guideImage1: string;
    guideImage2: string;
    guideImage3: string;
  }>({
    name: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    lockProviderId: "",
    lockProviderEndpoint: "",
    image: "",
    lat: "",
    long: "",
    username: "",
    password: "",
    amenigiesShare: "",
    ownerShare: "",
    selectedGroup: "",
    guideImage1: "",
    guideImage2: "",
    guideImage3: "",
  });

  const nextHandler = async () => {
    const { errors: fieldsErrors, isValid } = validator([
      {
        key: "name",
        value: name,
        type: "text",
      },
      {
        key: "address",
        value: address,
        type: "text",
      },

      {
        key: "city",
        value: city,
        type: "text",
      },

      {
        key: "state",
        value: state,
        type: "text",
      },
      {
        key: "zip",
        value: zip,
        type: "text",
      },

      {
        key: "lockProviderId",
        value: lockProviderId,
        type: "text",
      },

      {
        key: "lockProviderEndpoint",
        value: lockProviderEndpoint,
        type: "text",
      },

      {
        key: "image",
        value: image,
        type: "file",
      },

      {
        key: "lat",
        value: lat,
        type: "text",
      },

      {
        key: "long",
        value: long,
        type: "text",
      },

      {
        key: "username",
        value: username,
        type: "text",
      },

      {
        key: "password",
        value: password,
        type: "text",
      },

      {
        key: "amenigiesShare",
        value: amenigiesShare,
        type: "numberOnly",
        range: "0-100",
      },

      {
        key: "ownerShare",
        value: ownerShare,
        type: "numberOnly",
        range: "0-100",
      },

      {
        key: "selectedGroup",
        value: selectedGroup,
        type: "text",
      },

      {
        key: "guideImage1",
        value: guideImage1,
        type: "file",
      },

      {
        key: "guideImage2",
        value: guideImage2,
        type: "file",
      },

      {
        key: "guideImage3",
        value: guideImage3,
        type: "file",
      },
    ]);

    setErrors({ ...errors, ...fieldsErrors });
    if (isValid) {
      if (buildingId) {
        if (!updateBuildingLoading) {
          const successHandler = () => {
            setActiveTab("members");
            toastHelper.success("Building updated successfully");
          };
          const imagebase64 = await imageToBase64(image);
          const guideImage1base64 = await imageToBase64(guideImage1);
          const guideImage2base64 = await imageToBase64(guideImage2);
          const guideImage3base64 = await imageToBase64(guideImage3);

          dispatch(
            updateBuilding({
              buildingId: buildingId,
              buildingName: name,
              address: address,
              city: city,
              state: state,
              zip: zip,
              lockProviderId: lockProviderId,
              lockProviderEndpoint: lockProviderEndpoint,
              image: imagebase64,
              lat: lat,
              long: long,
              username: username,
              password: password,
              amenigiesShare: amenigiesShare,
              ownerShare: ownerShare,
              groupId: selectedGroup,
              guideImage1: guideImage1base64,
              guideImage2: guideImage2base64,
              guideImage3: guideImage3base64,
              successHandler,
            }),
          );
        }
      } else {
        if (!createBuildingLoading) {
          const successHandler = () => {
            setActiveTab("members");
            toastHelper.success("Building created successfully");
          };
          const imagebase64 = await imageToBase64(image);
          const guideImage1base64 = await imageToBase64(guideImage1);
          const guideImage2base64 = await imageToBase64(guideImage2);
          const guideImage3base64 = await imageToBase64(guideImage3);
          dispatch(
            createBuilding({
              buildingName: name,
              address: address,
              city: city,
              state: state,
              zip: zip,
              lockProviderId: lockProviderId,
              lockProviderEndpoint: lockProviderEndpoint,
              image: imagebase64,
              lat: lat,
              long: long,
              username: username,
              password: password,
              amenigiesShare: amenigiesShare,
              ownerShare: ownerShare,
              groupId: selectedGroup,
              guideImage1: guideImage1base64,
              guideImage2: guideImage2base64,
              guideImage3: guideImage3base64,
              successHandler,
            }),
          );
        }
      }
    }
  };

  useEffect(() => {
    if (buildingId) {
      dispatch(getBuildingByBuildingId({ buildingId }));
    }
    return () => {
      dispatch(clearGetBuildingByBuildingId());
    };
  }, [buildingId, dispatch]);

  useEffect(() => {
    if (getBuildingById) {
      setName(getBuildingById?.buildingName || "");
      setAddress(getBuildingById?.address || "");
      setCity(getBuildingById?.city || "");
      setState(getBuildingById?.state || "");
      setZip(getBuildingById?.zip || "");
      setLockProviderId(getBuildingById?.lockProvider?.id?.toString() || "");
      setLockProviderEndpoint(getBuildingById?.lockProviderEndPoint || "");
      setImage(getBuildingById?.image || null);
      setLat(getBuildingById?.lat || "");
      setLong(getBuildingById?.long || "");
      setUsername(getBuildingById?.username || "");
      setPassword(getBuildingById?.password || "");
      setAmenigiesShare(getBuildingById?.amenigiesShare || "");
      setOwnerShare(getBuildingById?.ownerShare || "");
      setSelectedGroup(getBuildingById?.groupId);
      setGuideImage1(getBuildingById?.guideImage1 || null);
      setGuideImage2(getBuildingById?.guideImage2 || null);
      setGuideImage3(getBuildingById?.guideImage3 || null);
    }
  }, [getBuildingById]);

  return (
    <React.Fragment>
      <div className={styles.mainContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Building Name</p>
          <input
            type="text"
            placeholder="Building Name"
            className={styles.input}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <p className={styles.error}>{errors.name}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Location/Address</p>
          <input
            type="text"
            placeholder="Location/Address"
            className={styles.input}
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <p className={styles.error}>{errors.address}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>City</p>
          <input
            type="text"
            placeholder="City"
            className={styles.input}
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
          <p className={styles.error}>{errors.city}</p>
        </div>
        <div className={styles.doubleInputContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>State</p>
            <select
              className={styles.input}
              value={state}
              onChange={(e) => setState(e.target.value)}
            >
              {!state && <option value="">Select State</option>}
              {LocalData.usStatesList.map((state) => (
                <option key={state.shortCode} value={state.shortCode}>
                  {state.name}
                </option>
              ))}
            </select>
            <p className={styles.error}>{errors.state}</p>
          </div>

          <div className={styles.inputContainer}>
            <p className={styles.label}>Zip Code</p>
            <input
              type="text"
              placeholder="Zip Code"
              className={styles.input}
              value={zip}
              onChange={(e) => setZip(e.target.value)}
            />
            <p className={styles.error}>{errors.zip}</p>
          </div>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Groups</p>
          <select
            className={styles.input}
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.target.value)}
          >
            {!selectedGroup && <option value="">Select Group</option>}
            {allGroups?.map((group, i) => (
              <option key={i} value={group?.id}>
                {group?.groupName}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.selectedGroup}</p>
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Amenigies Share (%)</p>
          <input
            type="text"
            placeholder="Amenigies Share"
            className={styles.input}
            value={amenigiesShare}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*\.?\d*$/.test(value)) {
                setAmenigiesShare(value);
              }
            }}
          />

          <p className={styles.error}>{errors.amenigiesShare}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Owner Share (%)</p>
          <input
            type="text"
            placeholder="Owner Share"
            className={styles.input}
            value={ownerShare}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*\.?\d*$/.test(value)) {
                setOwnerShare(value);
              }
            }}
          />

          <p className={styles.error}>{errors.ownerShare}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Latitude</p>
          <input
            type="text"
            placeholder="Latitude"
            className={styles.input}
            value={lat}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*\.?\d*$/.test(value)) {
                setLat(value);
              }
            }}
          />
          <p className={styles.error}>{errors.lat}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Longitude</p>
          <input
            type="text"
            placeholder="Longitude"
            className={styles.input}
            value={long}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*\.?\d*$/.test(value)) {
                setLong(value);
              }
            }}
          />
          <p className={styles.error}>{errors.long}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Username</p>
          <input
            type="text"
            placeholder="Username"
            className={styles.input}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <p className={styles.error}>{errors.username}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Password</p>
          <div className={styles.passwordInputContainer}>
            <input
              type={showPassword ? "text" : "password"}
              className={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button
              type="button"
              className={styles.showPasswordButton}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <FaRegEyeSlash className={styles.icon} />
              ) : (
                <FaRegEye className={styles.icon} />
              )}
            </button>
          </div>
          <p className={styles.error}>{errors.password}</p>
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Lock Provider</p>
          <select
            className={styles.input}
            value={lockProviderId}
            onChange={(e) => setLockProviderId(e.target.value)}
          >
            {!lockProviderId && <option value="">Select Lock Provider</option>}
            {lockProviders?.map((lockProvider) => (
              <option key={lockProvider.id} value={lockProvider.id}>
                {lockProvider.name}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.lockProviderId}</p>
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Lock Provider Endpoint</p>
          <input
            type="text"
            placeholder="Lock Provider Endpoint"
            className={styles.input}
            value={lockProviderEndpoint}
            onChange={(e) => setLockProviderEndpoint(e.target.value)}
          />
          <p className={styles.error}>{errors.lockProviderEndpoint}</p>
        </div>

        <div className={styles.imageInputContainer}>
          <p className={styles.label}>Building Image</p>
          <input
            className={styles.imageInput}
            type="file"
            hidden
            ref={ref}
            accept="image/*"
            value={""}
            onChange={(e) => setImage(e.target.files?.[0] || null)}
          />
          {image ? (
            <div className={styles.inputImageContainer}>
              <img
                className={styles.inputImage}
                src={imageUrlHelper(image)}
                alt="Building"
              />
              <div className={styles.iconContainer}>
                <IoClose
                  className={styles.icon}
                  onClick={() => setImage(null)}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.imageInputBox}
              onClick={() => ref.current?.click()}
            >
              <div className={styles.iconContainer}>
                <CiImageOn className={styles.icon} />
              </div>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Upload Image</p>
              </div>
            </div>
          )}
          <p className={styles.error}>{errors.image}</p>
        </div>

        <div className={styles.imageInputContainer}>
          <p className={styles.label}>Homepage Screenshot</p>
          <input
            className={styles.imageInput}
            type="file"
            hidden
            ref={guideImage1Ref}
            accept="image/*"
            value={""}
            onChange={(e) => setGuideImage1(e.target.files?.[0] || null)}
          />
          {guideImage1 ? (
            <div className={styles.inputImageContainer}>
              <img
                className={styles.inputImage}
                src={imageUrlHelper(guideImage1)}
                alt="GuideImage"
              />
              <div className={styles.iconContainer}>
                <IoClose
                  className={styles.icon}
                  onClick={() => setGuideImage1(null)}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.imageInputBox}
              onClick={() => guideImage1Ref.current?.click()}
            >
              <div className={styles.iconContainer}>
                <CiImageOn className={styles.icon} />
              </div>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Upload Image</p>
              </div>
            </div>
          )}
          <p className={styles.error}>{errors.guideImage1}</p>
        </div>

        <div className={styles.imageInputContainer}>
          <p className={styles.label}>Amenity List Screenshot</p>
          <input
            className={styles.imageInput}
            type="file"
            hidden
            ref={guideImage2Ref}
            accept="image/*"
            value={""}
            onChange={(e) => setGuideImage2(e.target.files?.[0] || null)}
          />
          {guideImage2 ? (
            <div className={styles.inputImageContainer}>
              <img
                className={styles.inputImage}
                src={imageUrlHelper(guideImage2)}
                alt="GuideImage2"
              />
              <div className={styles.iconContainer}>
                <IoClose
                  className={styles.icon}
                  onClick={() => setGuideImage2(null)}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.imageInputBox}
              onClick={() => guideImage2Ref.current?.click()}
            >
              <div className={styles.iconContainer}>
                <CiImageOn className={styles.icon} />
              </div>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Upload Image</p>
              </div>
            </div>
          )}
          <p className={styles.error}>{errors.guideImage2}</p>
        </div>

        <div className={styles.imageInputContainer}>
          <p className={styles.label}>Amenity Item Screenshot</p>
          <input
            className={styles.imageInput}
            type="file"
            hidden
            ref={guideImage3Ref}
            accept="image/*"
            value={""}
            onChange={(e) => setGuideImage3(e.target.files?.[0] || null)}
          />
          {guideImage3 ? (
            <div className={styles.inputImageContainer}>
              <img
                className={styles.inputImage}
                src={imageUrlHelper(guideImage3)}
                alt="GuideImage3"
              />
              <div className={styles.iconContainer}>
                <IoClose
                  className={styles.icon}
                  onClick={() => setGuideImage3(null)}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.imageInputBox}
              onClick={() => guideImage3Ref.current?.click()}
            >
              <div className={styles.iconContainer}>
                <CiImageOn className={styles.icon} />
              </div>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Upload Image</p>
              </div>
            </div>
          )}
          <p className={styles.error}>{errors.guideImage3}</p>
        </div>

        {createBuildingLoading || updateBuildingLoading ? <Loading /> : <></>}
        <div className={styles.bottomContainer}>
          <div className={styles.buttonContainer}>
            <button className={styles.button} onClick={nextHandler}>
              Next
            </button>
          </div>
        </div>
      </div>
      {getBuildingByIdLoading ? <Loading /> : <></>}
    </React.Fragment>
  );
}

export default BuildingInformation;
